import React from 'react'
import DisputeWindowTime from './DisputeWindowTime';
import { getTokenSymbol, formatDateTime, getBackgroundColor, formatSmartDecimal, getFormatedWeb3Address, sendGasFeeAsUsdt, getMarketFeeToken } from '../../utils/helpers';
import { APPEAL, DARK_THEME, DISPUTE, WINNER_PROPOSAL_MODE, USDT_MOCK_VALUE } from '../../utils/constants';
import { UNDER_DISPUTE_CHECK } from '../../utils/MarketStatus';
import { Accordion } from 'react-bootstrap';
import { encodeFunctionData } from 'viem';
import { getExtendTimeAndSignature } from '../../utils/services';
import OracleAbi from '../../utils/OracleAbi.json';
import { notifyError } from '../Toast';
import { DEFAULT_ERROR_HEADING } from '../../utils/ConstantMessages';
import MarketOutcomeMobile from './MarketOutcomeMobile';

const PoolFinalizationMobile = ({
    t,
    poolsdetail,
    winnerData,
    isPoolPrivate,
    handleShowReasoning,
    publicPoolResolverText,
    poolDisputed,
    isAppealed,
    smartAccount,
    handleShowCreateDispute,
    revealWinnerUi,
    revealWinner,
    timeExtendUi,
    poolUnderDisputeUi,
    publicPoolResolverAddress,
    disputeTimer,
    setDisputeTimer,
    extendDisputeTimer,
    ownermatch,
    handleShow14,
    isClaimWindowOpen,
    claimNotDisputed,
    decideWinnerTime,
    claimEligibility,
    setClaimNotDisputed,
    userliquidity,
    percentageindiv,
    web3,
    pair,
    price,
    swapbalance,
    poolDisputedWinner,
    claimcheck,
    claimvalue,
    sumOfClaimvalue,
    getClaims,
    poolPnl,
    theme,
    isPublicPoolResolverAi,
    disputeOrAppealText,
    decidedByText,
    setShowCreateDisputeOffCanvas,
    setShowEvidence,
    setShowEvidenceHistory,
    investedAmount,
    totalPayout,
    tokenData,
    setWinnerProposalMode,
    reSubmitOrFinalizeSpinner,
    showresubmit,
    setShowResubmit,
    oracleExtendedTimeNo,
    gasEstimateInUsdt,
    gasFeesSpinner,
    getEstimatedTxGasFee,
    setGasFeesSpiner,
    setPoolStatus,
    openClaimModal,
    openWalletConnect,
    hasTooEarlyHistory
}) => {

    const handleEstimateReSubmitAppealGas = async () => {
        setShowResubmit(true);
        setGasFeesSpiner(true)
        try {
            const timeSignature = await getExtendTimeAndSignature(publicPoolResolverAddress, smartAccount);
            if (timeSignature) {
                const callArgs = [
                    {
                        to: publicPoolResolverAddress,
                        data: encodeFunctionData({
                            abi: OracleAbi,
                            functionName: "extendTime",
                            args: [timeSignature.epoch, timeSignature.signature],
                        }),
                    },
                    { to: getMarketFeeToken(poolsdetail?.token).address, data: sendGasFeeAsUsdt(USDT_MOCK_VALUE, getMarketFeeToken(poolsdetail?.token).decimals) },
                ];
                await getEstimatedTxGasFee(callArgs, false);
            }
        } catch (err) {
            console.error('Error in extend time gas fee estimation:', err);
        }
    };

    const handleEstimateFinalizeWinnerGas = async () => {
        setShowResubmit(true);
        setGasFeesSpiner(true);
        try {
            const callArgs = [
                {
                    to: publicPoolResolverAddress,
                    data: encodeFunctionData({
                        abi: OracleAbi,
                        functionName: "calculateWinner",
                    }),
                },
                { to: getMarketFeeToken(poolsdetail?.token).address, data: sendGasFeeAsUsdt(USDT_MOCK_VALUE, getMarketFeeToken(poolsdetail?.token).decimals) },
            ];
            await getEstimatedTxGasFee(callArgs, false);
        } catch (err) {
            console.error('Error in finalize gas fee estimation:', err);
        }
    };

    const getClaimButtonState = () => {
        const winnerOptionId = Number(poolDisputedWinner)
            ? poolsdetail?.options?.find(opt => opt.choiceIndex === Number(poolDisputedWinner))?._id
            : poolsdetail?.winnerOption?.optionId;
        const hasInvestedShares = +(swapbalance?.[winnerOptionId]) !== 0;
        const hasLiquidity = +(userliquidity) !== 0;
        const canClaimBase = !claimcheck && smartAccount && (hasInvestedShares || hasLiquidity || claimvalue?.resolverReward > 0);
        const canClaim = (canClaimBase && isClaimWindowOpen && !claimNotDisputed);
        return { canClaim, hasInvestedShares };
    };
    const { canClaim, hasInvestedShares } = getClaimButtonState();
    const isResolutionProposer = poolsdetail?.winnerProposer?.user?.walletAddress?.toLowerCase() === smartAccount?.toLowerCase();
    const canDispute = isPublicPoolResolverAi || !isResolutionProposer;

    const winnerDotColor = getBackgroundColor(
        poolsdetail?.options?.findIndex(opt => opt._id === winnerData?.winnerId),
        theme,
        poolsdetail?.options?.length
    );

    const decidedByImg = theme === DARK_THEME
        ? <img src="\assets\olympus-outcomedark.svg" alt="img" className="img-fluid" />
        : <img src="\assets\olympus-outcome.svg" alt="img" className="img-fluid" />;

    const handleDisputeClick = () => {
        if (!smartAccount) {
            openWalletConnect();
            return;
        }
        if (disputeOrAppealText === DISPUTE) {
            setWinnerProposalMode(WINNER_PROPOSAL_MODE.DISPUTE);
            setShowCreateDisputeOffCanvas(true);
        }
        handleShowCreateDispute();
    };

    return (
        <>
            {poolsdetail?.poolFinalized && poolsdetail?.winnerOption && (
                <>
                    {!canClaim && !claimcheck && (
                        <>
                            {isClaimWindowOpen && claimNotDisputed && disputeOrAppealText === DISPUTE && (
                                <div className="proposed-outcome-flow-mobile">
                                    <div className="upper-field">
                                        <div className="inside-left">
                                            <p>Outcome determined</p>
                                            <h6>
                                                <span className="dot-color" style={{ backgroundColor: winnerDotColor }}></span>
                                                {winnerData?.winnerOption}
                                            </h6>
                                        </div>
                                        {isPublicPoolResolverAi && (
                                            <div className="outcome-decided">
                                                <p>Decided By</p>
                                                {decidedByImg}
                                            </div>
                                        )}
                                    </div>
                                    <div className="mid-field">
                                        <div className="inside-left">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                <path d="M16.2973 13.4999L10.2973 2.99992C10.1665 2.76908 9.97678 2.57707 9.74752 2.44348C9.51826 2.30989 9.25767 2.2395 8.99232 2.2395C8.72698 2.2395 8.46639 2.30989 8.23713 2.44348C8.00787 2.57707 7.81815 2.76908 7.68733 2.99992L1.68733 13.4999C1.55509 13.7289 1.48575 13.9889 1.48633 14.2533C1.48692 14.5178 1.55741 14.7774 1.69066 15.0058C1.82391 15.2342 2.01519 15.4234 2.2451 15.554C2.47501 15.6847 2.73538 15.7523 2.99983 15.7499H14.9998C15.263 15.7497 15.5215 15.6801 15.7493 15.5484C15.9771 15.4166 16.1662 15.2272 16.2977 14.9993C16.4292 14.7713 16.4984 14.5127 16.4983 14.2495C16.4982 13.9864 16.4289 13.7278 16.2973 13.4999Z" stroke="#DB5F2B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M9 6.75V9.75" stroke="#DB5F2B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M9 12.75H9.0075" stroke="#DB5F2B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            <p>Disagree?</p>
                                        </div>
                                        {canDispute ? (
                                            <div
                                                className="dispute-div"
                                                onClick={handleDisputeClick}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <p>Dispute</p>
                                                <DisputeWindowTime
                                                    claimNotDisputed={claimNotDisputed}
                                                    decideWinnerEndTime={decideWinnerTime}
                                                    claimEligibility={claimEligibility}
                                                    setClaimNotDisputed={setClaimNotDisputed}
                                                    disputeOrAppealText={disputeOrAppealText}
                                                    setPoolStatus={setPoolStatus}
                                                    isAppealed={isAppealed}
                                                />
                                            </div>
                                        ) : (
                                            <div className="dispute-div">
                                                <p>Window ends in</p>
                                                <DisputeWindowTime
                                                    claimNotDisputed={claimNotDisputed}
                                                    decideWinnerEndTime={decideWinnerTime}
                                                    claimEligibility={claimEligibility}
                                                    setClaimNotDisputed={setClaimNotDisputed}
                                                    disputeOrAppealText={disputeOrAppealText}
                                                    setPoolStatus={setPoolStatus}
                                                    isAppealed={isAppealed}
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div className="bottom-field">
                                        <button className="btn-history-mbl" onClick={() => { setShowEvidence(true); setShowEvidenceHistory(true); }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M7.99967 14.6666C11.6816 14.6666 14.6663 11.6818 14.6663 7.99992C14.6663 4.31802 11.6816 1.33325 7.99967 1.33325C4.31778 1.33325 1.33301 4.31802 1.33301 7.99992C1.33301 11.6818 4.31778 14.6666 7.99967 14.6666Z" stroke="#757575" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M8 4V8L10.6667 9.33333" stroke="#757575" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            <p>History</p>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5" fill="none">
                                                <path d="M0.296477 1.71L2.88648 4.3C3.27648 4.69 3.90648 4.69 4.29648 4.3L6.88648 1.71C7.51648 1.08 7.06648 0 6.17648 0L0.996477 0C0.106477 0 -0.333523 1.08 0.296477 1.71Z" fill="#757575" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            )}
                            {poolsdetail?.status === UNDER_DISPUTE_CHECK && (
                                <div className="proposed-outcome-flow-mobile">
                                    <div className="upper-field">
                                        <div className="inside-left">
                                            <p>Decided Outcome</p>
                                            <h6>
                                                <span className="dot-color" style={{ backgroundColor: winnerDotColor }}></span>
                                                {winnerData?.winnerOption}
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="raised-dispute">
                                        <div className="upper-text">
                                            <h6>
                                                {poolsdetail?.disputeData?.caller?.toLowerCase() === smartAccount?.toLowerCase()
                                                    ? 'You have raised a dispute'
                                                    : 'A Dispute Has Been Raised'}
                                            </h6>
                                            <p>Dispute Resolution by {decidedByImg}</p>
                                        </div>
                                    </div>
                                    <div className="bottom-field">
                                        <button className="btn-history-mbl" onClick={() => { setShowEvidence(true); setShowEvidenceHistory(true); }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M7.99967 14.6666C11.6816 14.6666 14.6663 11.6818 14.6663 7.99992C14.6663 4.31802 11.6816 1.33325 7.99967 1.33325C4.31778 1.33325 1.33301 4.31802 1.33301 7.99992C1.33301 11.6818 4.31778 14.6666 7.99967 14.6666Z" stroke="#757575" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M8 4V8L10.6667 9.33333" stroke="#757575" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            <p>History</p>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5" fill="none">
                                                <path d="M0.296477 1.71L2.88648 4.3C3.27648 4.69 3.90648 4.69 4.29648 4.3L6.88648 1.71C7.51648 1.08 7.06648 0 6.17648 0L0.996477 0C0.106477 0 -0.333523 1.08 0.296477 1.71Z" fill="#757575" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            )}
                            {isClaimWindowOpen && claimNotDisputed && disputeOrAppealText === APPEAL && (
                                <div className="proposed-outcome-flow-mobile">
                                    <div className="upper-field">
                                        <div className="inside-left">
                                            <p>Market outcome</p>
                                            <h6>
                                                <span className="dot-color" style={{ backgroundColor: winnerDotColor }}></span>
                                                {winnerData?.winnerOption}
                                            </h6>
                                        </div>
                                        <div className="outcome-decided">
                                            <p>Decided By</p>
                                            {decidedByImg}
                                        </div>
                                    </div>
                                    <div className="raised-dispute wanttoappeal">
                                        <div className="upper-text">
                                            <h6>Dispute resolved. Want to appeal? </h6>
                                            <p>This will escalate the final decision to human reviewers.</p>
                                        </div>
                                        <div
                                            className="dispute-div"
                                            onClick={() => {
                                                if (!smartAccount) {
                                                    notifyError(DEFAULT_ERROR_HEADING, 'Please connect your wallet to raise an appeal');
                                                } else {
                                                    handleShowCreateDispute();
                                                }
                                            }}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <p>Appeal</p>
                                            <DisputeWindowTime
                                                claimNotDisputed={claimNotDisputed}
                                                decideWinnerEndTime={decideWinnerTime}
                                                claimEligibility={claimEligibility}
                                                setClaimNotDisputed={setClaimNotDisputed}
                                                disputeOrAppealText={disputeOrAppealText}
                                                setPoolStatus={setPoolStatus}
                                                isAppealed={isAppealed}
                                            />
                                        </div>
                                    </div>
                                    <div className="bottom-field">
                                        <button className="btn-history-mbl" onClick={() => { setShowEvidence(true); setShowEvidenceHistory(true); }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M7.99967 14.6666C11.6816 14.6666 14.6663 11.6818 14.6663 7.99992C14.6663 4.31802 11.6816 1.33325 7.99967 1.33325C4.31778 1.33325 1.33301 4.31802 1.33301 7.99992C1.33301 11.6818 4.31778 14.6666 7.99967 14.6666Z" stroke="#757575" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M8 4V8L10.6667 9.33333" stroke="#757575" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            <p>History</p>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5" fill="none">
                                                <path d="M0.296477 1.71L2.88648 4.3C3.27648 4.69 3.90648 4.69 4.29648 4.3L6.88648 1.71C7.51648 1.08 7.06648 0 6.17648 0L0.996477 0C0.106477 0 -0.333523 1.08 0.296477 1.71Z" fill="#757575" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                    <div className='right-side'>
                        {!poolUnderDisputeUi &&
                            !timeExtendUi &&
                            isClaimWindowOpen &&
                            !(claimNotDisputed && (disputeOrAppealText === APPEAL || disputeOrAppealText === DISPUTE)) && (
                                <>
                                    <MarketOutcomeMobile
                                        winnerData={winnerData}
                                        poolsdetail={poolsdetail}
                                        setShowEvidence={setShowEvidence}
                                        setShowEvidenceHistory={setShowEvidenceHistory}
                                        hasTooEarlyHistory={hasTooEarlyHistory}
                                    />
                                </>
                            )}
                    </div>
                    {((timeExtendUi || poolUnderDisputeUi) && poolDisputed && isAppealed) && (
                        <MarketOutcomeMobile
                            winnerData={winnerData}
                            poolsdetail={poolsdetail}
                            setShowEvidence={setShowEvidence}
                            setShowEvidenceHistory={setShowEvidenceHistory}
                            revealWinner={revealWinner}
                            revealWinnerUi={revealWinnerUi}
                            timeExtendUi={timeExtendUi}
                            extendDisputeTimer={extendDisputeTimer}
                            publicPoolResolverAddress={publicPoolResolverAddress}
                            disputeTimer={disputeTimer}
                            setDisputeTimer={setDisputeTimer}
                            reSubmitOrFinalizeSpinner={reSubmitOrFinalizeSpinner}
                            showresubmit={showresubmit}
                            setShowResubmit={setShowResubmit}
                            handleEstimateReSubmitAppealGas={handleEstimateReSubmitAppealGas}
                            handleEstimateFinalizeWinnerGas={handleEstimateFinalizeWinnerGas}
                            oracleExtendedTimeNo={oracleExtendedTimeNo}
                            gasEstimateInUsdt={gasEstimateInUsdt}
                            gasFeesSpinner={gasFeesSpinner}
                            poolUnderDisputeUi={poolUnderDisputeUi}
                            poolDisputed={poolDisputed}
                            isAppealed={isAppealed}
                            hasTooEarlyHistory={hasTooEarlyHistory}
                        />
                    )}
                </>
            )}
            {revealWinnerUi && (
                <MarketOutcomeMobile
                    winnerData={winnerData}
                    poolsdetail={poolsdetail}
                    setShowEvidence={setShowEvidence}
                    setShowEvidenceHistory={setShowEvidenceHistory}
                    revealWinner={revealWinner}
                    revealWinnerUi={revealWinnerUi}
                    timeExtendUi={timeExtendUi}
                    extendDisputeTimer={extendDisputeTimer}
                    publicPoolResolverAddress={publicPoolResolverAddress}
                    disputeTimer={disputeTimer}
                    setDisputeTimer={setDisputeTimer}
                    reSubmitOrFinalizeSpinner={reSubmitOrFinalizeSpinner}
                    showresubmit={showresubmit}
                    setShowResubmit={setShowResubmit}
                    handleEstimateReSubmitAppealGas={handleEstimateReSubmitAppealGas}
                    handleEstimateFinalizeWinnerGas={handleEstimateFinalizeWinnerGas}
                    oracleExtendedTimeNo={oracleExtendedTimeNo}
                    gasEstimateInUsdt={gasEstimateInUsdt}
                    gasFeesSpinner={gasFeesSpinner}
                    poolUnderDisputeUi={poolUnderDisputeUi}
                    poolDisputed={poolDisputed}
                    isAppealed={isAppealed}
                    hasTooEarlyHistory={hasTooEarlyHistory}
                />
            )}
            {hasTooEarlyHistory && (
                <MarketOutcomeMobile
                    winnerData={winnerData}
                    poolsdetail={poolsdetail}
                    setShowEvidence={setShowEvidence}
                    setShowEvidenceHistory={setShowEvidenceHistory}
                    revealWinner={revealWinner}
                    revealWinnerUi={revealWinnerUi}
                    timeExtendUi={timeExtendUi}
                    extendDisputeTimer={extendDisputeTimer}
                    publicPoolResolverAddress={publicPoolResolverAddress}
                    disputeTimer={disputeTimer}
                    setDisputeTimer={setDisputeTimer}
                    reSubmitOrFinalizeSpinner={reSubmitOrFinalizeSpinner}
                    showresubmit={showresubmit}
                    setShowResubmit={setShowResubmit}
                    handleEstimateReSubmitAppealGas={handleEstimateReSubmitAppealGas}
                    handleEstimateFinalizeWinnerGas={handleEstimateFinalizeWinnerGas}
                    oracleExtendedTimeNo={oracleExtendedTimeNo}
                    gasEstimateInUsdt={gasEstimateInUsdt}
                    gasFeesSpinner={gasFeesSpinner}
                    poolUnderDisputeUi={poolUnderDisputeUi}
                    poolDisputed={poolDisputed}
                    isAppealed={isAppealed}
                    hasTooEarlyHistory={hasTooEarlyHistory}
                />
            )}
            <div className="right-side">
                {poolsdetail?.poolFinalized && !poolsdetail?.winnerOption && (
                    <div className="winnerdecideui" style={{ border: "none", padding: "0" }}>
                        {(isPoolPrivate || !isPublicPoolResolverAi) && ownermatch
                            ? <p className="undersidputetext">{t("Market is Closed!")}</p>
                            : (isPoolPrivate || !isPublicPoolResolverAi)
                                ? <p className="undersidputetext">{t("Market is Closed! Please wait for the creator to decide winner.")}</p>
                                : <div className="market-outcome">
                                    <Accordion className={poolsdetail?.version < 3 ? 'no-toggle' : ''}>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>
                                                <div className="left-text">
                                                    <p>Resolution in Progress{' '}
                                                        {isPublicPoolResolverAi && (
                                                            <>
                                                                by <br />
                                                                {theme === DARK_THEME
                                                                    ? <img src="\assets\olympus-outcomedark.svg" alt="img" className="img-fluid" style={{ maxWidth: "120px", marginTop: "15px" }} />
                                                                    : <img src="\assets\olympus-outcome.svg" alt="img" className="img-fluid" style={{ maxWidth: "120px", marginTop: "15px" }} />
                                                                }
                                                            </>
                                                        )}
                                                    </p>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div className="parent-body">
                                                    <div className="left-text">
                                                        <p>Closed by</p>
                                                        <h6>
                                                            <img src={poolsdetail?.winnerProposer?.user?.profilePic} alt="img" className="img-fluid" />
                                                            {poolsdetail?.winnerProposer?.user?.name || getFormatedWeb3Address(poolsdetail?.winnerProposer?.user?.walletAddress, true)}
                                                            <span>{poolsdetail?.winnerProposer?.role}</span>
                                                        </h6>
                                                    </div>
                                                    <div className="left-text">
                                                        <p>Proposed Time</p>
                                                        <h6>{formatDateTime(poolsdetail?.winnerProposer?.createdAt)}</h6>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>
                        }
                        {((isPoolPrivate || !isPublicPoolResolverAi) && ownermatch) && (
                            <button onClick={() => handleShow14()} className="btncreatedispute" style={{ background: "var(--button-bg)", color: "var(--text-color6)", border: "none" }}>{t('Decide Winner')}</button>
                        )}
                    </div>
                )}
            </div>
        </>
    )
}

export default PoolFinalizationMobile
